import { drawArrow } from "./arrows";

export const frenchDoorL = (p5, trait, width, yurtTrait) => {
  const xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + 5 * trait.pixels;
  const boardWidth = trait.twoByW;
  let plate = 10.5 * trait.pixels;
  const doorH = 81.5 * trait.pixels;
  const header = trait.frenchHeader;
  const wallBottom = ycenter + yurtTrait.h/2 + boardWidth/2

  if (trait.frenchW === "6ft") {
    plate = 16.5 * trait.pixels;
  }

  const plateLeft1 = {
    x: xcenter + (trait.w / 2 + boardWidth / 2 - plate),
    y: ycenter + yurtTrait.h / 2 - doorH / 2,
    w: boardWidth,
    h: doorH,
  };

  const plateLeft2 = {
    x: xcenter + (trait.w / 2 + boardWidth / 2 - plate),
    y: ycenter - yurtTrait.h / 2 + (yurtTrait.h - doorH - header) / 2,
    w: boardWidth,
    h: yurtTrait.h - doorH - header,
  };

  const plateBottom = {
    x: xcenter + (trait.w / 2 - boardWidth / 2 - plate / 2),
    y: wallBottom - doorH - header - boardWidth,
    w: plate + boardWidth,
    h: boardWidth,
  };

  const plateRight = {
    x: xcenter + (trait.w / 2 - boardWidth / 2),
    y: ycenter - yurtTrait.h / 2 + (yurtTrait.h - doorH - header) / 2,
    w: boardWidth,
    h: yurtTrait.h - doorH - header,
  };

  const rightBoard = {
    x: xcenter + (trait.w / 2 - trait.twoByW / 2 - plate),
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  const leftBoard = {
    x: xcenter - (trait.w / 2 - trait.twoByW / 2),
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  const bottomBoard = {
    x: xcenter,
    y: ycenter + (yurtTrait.h / 2 + boardWidth / 2),
    w: trait.w,
    h: boardWidth,
  };

  const topBoard = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth / 2) + boardWidth / 2,
    w: trait.w,
    h: boardWidth,
  };

  const rafterPlate = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth),
    w: trait.w,
    h: boardWidth,
  };

  let centerStud = {
    x: leftBoard.x + (rightBoard.x - leftBoard.x) / 2,
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  // if (yurtTrait.stud < 24) {
  //   centerStud.x = xcenter - trait.w / 3 / 2;
  // }

  const blocking = {
    x: xcenter - plate / 2,
    y: ycenter - (yurtTrait.h / 2 + boardWidth / 2) + 96 * trait.pixels,
    w: trait.w - plate,
    h: trait.twoByH,
  };

  // right board
  p5.push();
  p5.fill("lightgrey");
  p5.rectMode(p5.CENTER);
  p5.rect(blocking.x, blocking.y, blocking.w, blocking.h);
  p5.rect(centerStud.x, centerStud.y, centerStud.w, centerStud.h);
  p5.rect(plateLeft1.x, plateLeft1.y, plateLeft1.w, plateLeft1.h);
  p5.rect(plateLeft2.x, plateLeft2.y, plateLeft2.w, plateLeft2.h);
  p5.rect(plateRight.x, plateRight.y, plateRight.w, plateRight.h);
  p5.rect(plateBottom.x, plateBottom.y, plateBottom.w, plateBottom.h);
  p5.rect(rightBoard.x, rightBoard.y, rightBoard.w, rightBoard.h);
  p5.rect(leftBoard.x, leftBoard.y, leftBoard.w, leftBoard.h);
  p5.rect(topBoard.x, topBoard.y, topBoard.w, topBoard.h);
  p5.rect(rafterPlate.x, rafterPlate.y, rafterPlate.w, rafterPlate.h);
  p5.rect(bottomBoard.x, bottomBoard.y, bottomBoard.w, bottomBoard.h);
  p5.pop();

  p5.push();
  p5.strokeWeight(0.5);
  p5.line(
    plateLeft1.x,
    plateLeft1.y - plateLeft1.h / 2,
    plateRight.x,
    plateLeft1.y - plateLeft1.h / 2
  );
  p5.pop();

  const arrowDistance = 6 * trait.pixels;

  // right arrow
  let v0 = p5.createVector(
    bottomBoard.x + bottomBoard.w / 2 + arrowDistance,
    bottomBoard.y + bottomBoard.h / 2
  );
  let v1 = p5.createVector(0, -yurtTrait.h - boardWidth * 2.5);
  drawArrow(p5, v0, v1, yurtTrait.h, trait.pixels);

  // left arrow
  let v2 = p5.createVector(
    bottomBoard.x - bottomBoard.w / 2 - arrowDistance,
    bottomBoard.y + bottomBoard.h / 2 - boardWidth
  );
  let v3 = p5.createVector(0, -yurtTrait.h + trait.twoByW);
  drawArrow(p5, v2, v3, yurtTrait.h - boardWidth * 3, trait.pixels);

  // plate arrow

  let plate1 = p5.createVector(plateBottom.x, plateBottom.y - boardWidth / 2);

  let plate2 = p5.createVector(0, -(yurtTrait.h - doorH - header - boardWidth));

  if (!trait.windows) {
    drawArrow(
      p5,
      plate1,
      plate2,
      trait.h - doorH - header - boardWidth * 4,
      trait.pixels
    );
  }

  // door arrow
  let door1 = p5.createVector(
    xcenter + (trait.w / 2 - boardWidth / 2 - plate / 2),
    ycenter - yurtTrait.h / 2 + (yurtTrait.h - doorH)
  );
  let door2 = p5.createVector(0, doorH);
  drawArrow(p5, door1, door2, doorH, trait.pixels);

  p5.push();
  p5.strokeWeight(0.5);
  p5.line(
    centerStud.x + (rightBoard.x - centerStud.x) / 2,
    blocking.y + blocking.h / 2,
    centerStud.x + (leftBoard.x - centerStud.x) / 2,
    blocking.y + 167
  );
  p5.textAlign(p5.CENTER);
  p5.text(
    `${(rightBoard.x - leftBoard.x - trait.twoByW * 3) / 2 / trait.pixels}"`,
    centerStud.x + (leftBoard.x - centerStud.x) / 2 + 5,
    blocking.y + 180
  );
  p5.pop();

  p5.push();
  p5.fill(150);
  p5.textAlign(p5.CENTER, p5.CENTER);
  p5.textSize(80 / trait.pixels);
  p5.text(
    `2 x ${Math.ceil(trait.frenchHeader / trait.pixels)}`,
    plateLeft1.x + (plateRight.x - plateLeft1.x) / 2,
    plateLeft1.y - plateLeft1.h / 2 - header / 1.5
  );
  const headerTypes = ["SINGLE", "DOUBLE", "TRIPLE"];
  p5.text(
    `${headerTypes[trait.frenchHeaderAmount / trait.pixels]}`,
    plateLeft1.x + (plateRight.x - plateLeft1.x) / 2,
    plateLeft1.y - plateLeft1.h / 2 - header / 3.5
  );
  p5.pop();
};

export const frenchDoorR = (p5, trait, width, yurtTrait) => {
  const xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + 5 * trait.pixels;
  const boardWidth = trait.twoByW;
  let plate = 10.5 * trait.pixels;
  const doorH = 81.5 * trait.pixels;
  const header = trait.frenchHeader;

  if (trait.frenchW === "6ft") {
    plate = 16.5 * trait.pixels;
  }

  const plateR1 = {
    x: xcenter - (trait.w / 2 + boardWidth / 2 - plate),
    y: ycenter + yurtTrait.h / 2 - doorH / 2,
    w: boardWidth,
    h: doorH,
  };

  const plateR2 = {
    x: xcenter - (trait.w / 2 + boardWidth / 2 - plate),
    y: ycenter - yurtTrait.h / 2 + (yurtTrait.h - doorH - header) / 2,
    w: boardWidth,
    h: yurtTrait.h - doorH - header,
  };

  const plateBottom = {
    x: xcenter - (trait.w / 2 - boardWidth / 2 - plate / 2),
    y: ycenter - yurtTrait.h / 2 + (yurtTrait.h - doorH - header),
    w: plate + boardWidth,
    h: boardWidth,
  };

  const plateL = {
    x: xcenter - (trait.w / 2 - boardWidth / 2),
    y: ycenter - yurtTrait.h / 2 + (yurtTrait.h - doorH - header) / 2,
    w: boardWidth,
    h: yurtTrait.h - doorH - header,
  };

  const rightBoard = {
    x: xcenter + (trait.w / 2 - trait.twoByW / 2),
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  const leftBoard = {
    x: xcenter - (trait.w / 2 - trait.twoByW / 2 - plate),
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  const bottomBoard = {
    x: xcenter,
    y: ycenter + (yurtTrait.h / 2 + boardWidth / 2),
    w: trait.w,
    h: boardWidth,
  };

  const topBoard = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth / 2) + boardWidth / 2,
    w: trait.w,
    h: boardWidth,
  };

  const rafterPlate = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth),
    w: trait.w,
    h: boardWidth,
  };

  const centerStud = {
    x: leftBoard.x + (rightBoard.x - leftBoard.x) / 2,
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  // if (yurtTrait.stud < 24) {
  //   centerStud.x = xcenter + trait.w / 3 / 2;
  // }

  const blocking = {
    x: xcenter + plate / 2,
    y: ycenter - (yurtTrait.h / 2 + boardWidth / 2) + 96 * trait.pixels,
    w: trait.w - plate,
    h: trait.twoByH,
  };

  // right board
  p5.push();
  p5.rectMode(p5.CENTER);
  p5.fill("lightgrey");

  p5.rect(blocking.x, blocking.y, blocking.w, blocking.h);

  p5.rect(centerStud.x, centerStud.y, centerStud.w, centerStud.h);

  p5.rect(plateR1.x, plateR1.y, plateR1.w, plateR1.h);
  p5.rect(plateR2.x, plateR2.y, plateR2.w, plateR2.h);
  p5.rect(plateL.x, plateL.y, plateL.w, plateL.h);
  p5.rect(plateBottom.x, plateBottom.y, plateBottom.w, plateBottom.h);
  p5.rect(rightBoard.x, rightBoard.y, rightBoard.w, rightBoard.h);
  p5.rect(leftBoard.x, leftBoard.y, leftBoard.w, leftBoard.h);
  p5.rect(topBoard.x, topBoard.y, topBoard.w, topBoard.h);
  p5.rect(rafterPlate.x, rafterPlate.y, rafterPlate.w, rafterPlate.h);
  p5.rect(bottomBoard.x, bottomBoard.y, bottomBoard.w, bottomBoard.h);

  p5.pop();

  const arrowDistance = 6 * trait.pixels;

  // right arrow
  let v0 = p5.createVector(
    bottomBoard.x + bottomBoard.w / 2 + arrowDistance,
    bottomBoard.y + bottomBoard.h / 2
  );
  let v1 = p5.createVector(0, -yurtTrait.h - boardWidth * 2.5);
  drawArrow(p5, v0, v1, yurtTrait.h, trait.pixels);

  // left arrow
  let v2 = p5.createVector(
    bottomBoard.x - bottomBoard.w / 2 - arrowDistance,
    bottomBoard.y + bottomBoard.h / 2 - boardWidth
  );
  let v3 = p5.createVector(0, -yurtTrait.h + trait.twoByW);
  drawArrow(p5, v2, v3, yurtTrait.h - boardWidth * 3, trait.pixels);

  // door arrow
  let door1 = p5.createVector(
    xcenter - (trait.w / 2 - boardWidth / 2 - plate / 2),
    ycenter - yurtTrait.h / 2 + (yurtTrait.h - doorH) + boardWidth / 2
  );
  let door2 = p5.createVector(0, doorH - boardWidth / 2);
  drawArrow(p5, door1, door2, doorH, trait.pixels);

  // plate arrow

  let plate1 = p5.createVector(plateBottom.x, plateBottom.y - boardWidth / 2);
  let plate2 = p5.createVector(0, -(yurtTrait.h - doorH - header - boardWidth));

  if (!trait.windows) {
    drawArrow(
      p5,
      plate1,
      plate2,
      trait.h - doorH - header - boardWidth * 4,
      trait.pixels
    );
  }

  p5.push();
  p5.strokeWeight(0.5);
  p5.line(
    centerStud.x + (leftBoard.x - centerStud.x) / 2,
    blocking.y + blocking.h / 2,
    centerStud.x + (rightBoard.x - centerStud.x) / 2,
    blocking.y + 167
  );
  p5.textAlign(p5.CENTER);
  p5.text(
    `${(rightBoard.x - leftBoard.x - trait.twoByW * 3) / 2 / trait.pixels}"`,
    centerStud.x + (rightBoard.x - centerStud.x) / 2 + 5,
    blocking.y + 180
  );
  p5.pop();

  p5.push();
  p5.strokeWeight(0.5);
  p5.line(
    plateR1.x,
    plateR1.y - plateR1.h / 2,
    plateL.x,
    plateR1.y - plateR1.h / 2
  );
  p5.pop();

  p5.push();
  p5.fill(150);
  p5.textAlign(p5.CENTER, p5.CENTER);
  p5.textSize(80 / trait.pixels);
  p5.text(
    `2 x ${Math.ceil(trait.frenchHeader / trait.pixels)}`,
    plateR1.x + (plateL.x - plateR1.x) / 2,
    plateR1.y - plateR1.h / 2 - header / 1.5
  );
  const headerTypes = ["SINGLE", "DOUBLE", "TRIPLE"];
  p5.text(
    `${headerTypes[trait.frenchHeaderAmount / trait.pixels]}`,
    plateR1.x + (plateL.x - plateR1.x) / 2,
    plateR1.y - plateR1.h / 2 - header / 3.5
  );
  p5.pop();
};

export const frenchDoorC = (p5, trait, width, yurtTrait) => {
  const xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + 5 * trait.pixels;
  const boardWidth = trait.twoByW;
  const doorH = 81.5 * trait.pixels;
  const header = trait.frenchHeader;

  const rightBoard = {
    x: xcenter + (trait.w / 2 - trait.twoByW / 2),
    y: ycenter - (doorH + header) / 2,
    w: boardWidth,
    h: yurtTrait.h - doorH - header,
  };

  const leftBoard = {
    x: xcenter - (trait.w / 2 - trait.twoByW / 2),
    y: ycenter - (doorH + header) / 2,
    w: boardWidth,
    h: yurtTrait.h - doorH - header,
  };

  const bottomBoard = {
    x: xcenter,
    y: ycenter + yurtTrait.h / 2 - doorH - header,
    w: trait.w,
    h: boardWidth,
  };

  const topBoard = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth / 2) + boardWidth / 2,
    w: trait.w,
    h: boardWidth,
  };

  const rafterPlate = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth),
    w: trait.w,
    h: boardWidth,
  };

  const centerStud = {
    x: xcenter,
    y: ycenter - (doorH + header) / 2,
    w: boardWidth,
    h: yurtTrait.h - doorH - header,
  };

  // right board
  p5.push();
  p5.rectMode(p5.CENTER);
  p5.fill("lightgrey");

  if (yurtTrait.stud / trait.pixels >= 24) {
    p5.rect(centerStud.x, centerStud.y, centerStud.w, centerStud.h);
  } else {
    p5.rect(
      centerStud.x - trait.w / 3 / 2,
      centerStud.y,
      centerStud.w,
      centerStud.h
    );
    p5.rect(
      centerStud.x + trait.w / 3 / 2,
      centerStud.y,
      centerStud.w,
      centerStud.h
    );
  }

  p5.rect(rightBoard.x, rightBoard.y, rightBoard.w, rightBoard.h);
  p5.rect(leftBoard.x, leftBoard.y, leftBoard.w, leftBoard.h);
  p5.rect(topBoard.x, topBoard.y, topBoard.w, topBoard.h);
  p5.rect(rafterPlate.x, rafterPlate.y, rafterPlate.w, rafterPlate.h);
  p5.rect(bottomBoard.x, bottomBoard.y, bottomBoard.w, bottomBoard.h);

  p5.pop();

  p5.push();
  p5.strokeWeight(0.5);
  p5.stroke(150);
  p5.fill(150);
  p5.line(
    leftBoard.x - boardWidth / 2,
    leftBoard.y + leftBoard.h / 2 + header,
    rightBoard.x + boardWidth / 2,
    leftBoard.y + leftBoard.h / 2 + header
  );
  p5.textAlign(p5.CENTER, p5.CENTER);
  p5.textSize(80 / trait.pixels);
  p5.text(
    `2 x ${Math.ceil(trait.frenchHeader / trait.pixels)}`,
    centerStud.x,
    centerStud.y + centerStud.h / 2 + header / 1.5
  );
  const headerTypes = ["SINGLE", "DOUBLE", "TRIPLE"];
  p5.text(
    `${headerTypes[trait.frenchHeaderAmount / trait.pixels]}`,
    centerStud.x,
    centerStud.y + centerStud.h / 2 + header / 3
  );
  p5.pop();

  const arrowDistance = 6 * trait.pixels;

  // right arrow
  let v0 = p5.createVector(
    bottomBoard.x + bottomBoard.w / 2 + arrowDistance,
    bottomBoard.y + bottomBoard.h / 2
  );
  let v1 = p5.createVector(0, -(yurtTrait.h - doorH - header + boardWidth * 2));
  drawArrow(
    p5,
    v0,
    v1,
    yurtTrait.h - doorH - header - boardWidth,
    trait.pixels
  );

  // left arrow
  let v2 = p5.createVector(
    bottomBoard.x - bottomBoard.w / 2 - arrowDistance,
    bottomBoard.y + bottomBoard.h / 2 - boardWidth
  );
  let v3 = p5.createVector(0, -(yurtTrait.h - doorH - header - boardWidth));
  drawArrow(
    p5,
    v2,
    v3,
    yurtTrait.h - doorH - header - boardWidth * 4,
    trait.pixels
  );
};
